<script>
  let m = {
    methods: {
      getNavType () {
        if (!this.SelectSprites_Msg || (this.SelectSprites_Msg && !this.SelectSprites_Msg.length)) {
          return;
        }
        let { type } = this.SelectSprites_Msg[0];
        let { fileType } = this.SelectSprites_Msg[0].option;
        let navs = {
          'scenes': [],
          'bg': [],
          'text': [11, 12, 13, 30],
          'characters': [10, 57, 100, 118],
          'props': [3, 4, 5, 19],
          // 'shapes': [6, 7, 8, 9, 28, 29, 33],
          // 'gif': [32],
          'sound': [],
          'personal.gif': [34],
          'personal.video': [26, 27]
        };
        let navs2 = {
          'scenes': [],
          'bg': [],
          'text': ['Text'],
          'characters': ['Lottie', 'Gif'],
          'props': ['Image'],
          // 'shapes': ['Svg', 'Shape', 'Chart'],
          // 'gif': ['Gif'],
          'sound': [],
          'personal.gif': ['Gif'],
          'personal.video': ['Video']
        }
        if (fileType != null) {
          return find(navs, fileType);
        } else {
          return find(navs2, type);
        }

        function find (navs, targetKey) {
          let myKey = Object.keys(navs).filter((key) => {
            return navs[key].indexOf(targetKey) > -1;
          })[0];
          return myKey || 'props';
        }
      },
    }
  }

  export default m;
</script>



// WEBPACK FOOTER //
// src/components/mixins/getNavType.vue